module.exports = __webpack_public_path__ + "img/circle.f4a13f97.svg";